import { AiContentCheckbox } from 'components/Composer/CustomizePostBlock/AiContentCheckbox'
import { AiContentFacebookPhotoNote } from 'components/Composer/CustomizePostBlock/AiContentFacebookPhotoNote'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setComposerAiContent } from 'services/compose'
import {
  composerAiContentFacebookPhotoSelector, composerAiContentSelector, composerWithImagesSelector
} from 'services/compose/selectors'
import { StoreThunkDispatch } from 'store/state'
import AltText from './AltText'
import styles from './MediaPostOptions.pcss'

export function MediaPostOptions() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const aiContent = useSelector(composerAiContentSelector)
  const withImages = useSelector(composerWithImagesSelector)
  const facebookPhoto = useSelector(composerAiContentFacebookPhotoSelector)

  const onAiContentChange = (value: boolean) => {
    dispatch(setComposerAiContent(value))
  }

  if (!aiContent.visible && !withImages) {
    return null
  }

  return (
    <div className={styles.postOptionsBox}>
      <div className={styles.postOptionsHeader}>
        Post options
      </div>
      <div className={styles.postOptions}>
        {aiContent.visible && (
          <div>
            <AiContentCheckbox
              checked={aiContent.checked}
              id="composer-ai-content"
              variant="switch"
              onChange={onAiContentChange}
            />
            <p className={styles.hint}><FormattedMessage id="composer.labels.ai-content.info" /></p>
            {facebookPhoto && <AiContentFacebookPhotoNote className={styles.hint} />}
          </div>
        )}
        {withImages && (
          <div>
            <AltText
              hint={
                <p className={styles.hint}>
                  <FormattedMessage id="composer.hints.alt-text" />
                </p>
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default MediaPostOptions
